import {
    HOME_PAGE_CONTENT,
    FETCH_REPORTEE,
    LAST_FEWS_DAYS_INACTIVE_ACCOUNT, FILTER
} from "./type";

const initialState = {
    homePageDetails:[],
    reportee:[],
    inactiveAccount:[],
    filterDetails:[]
};

const Common = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case HOME_PAGE_CONTENT:
            return {
                ...state,
                homePageDetails: payload,
            };
        case FETCH_REPORTEE:
            return {
                ...state,
                reportee: payload,
            };
        case LAST_FEWS_DAYS_INACTIVE_ACCOUNT:
            return {
                ...state,
                inactiveAccount: payload,
            };
        case FILTER:
            return {
                ...state,
                filterDetails: payload,
            };
        default:
            return {...state};
    }
};

export default Common;